/*
 * @Author: your name
 * @Date: 2021-04-28 13:22:03
 * @LastEditTime: 2026-09-02 13:42:39
 * @LastEditors: zl21 602659667@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /burgeon-project-logic/config/module/modal/order.config.js
 */
// 订单中心
export default {
  DC_B_ORDER_ADJUST_ADD: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/adjustAdd.vue'
    )
  },
  SOLDOUT: { // 平台店铺商品发布-下架
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/pages/orderCenter/productRelease/SOLDOUT.vue'
    )
  },
  EDITAMT: { // 平台店铺商品发布-零售价
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/pages/orderCenter/productRelease/EDITAMT.vue'
    )
  },
  SENDORDERRECEIVING: { // 全渠道自提单-拒单
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/pages/orderCenter/omniChannel/dialog/dialogRejectOrder.vue'
    )
  },
  SENDORDERREFUSEORDER: { // 全渠道自提单-核销
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/pages/orderCenter/omniChannel/dialog/dialogChargeOff.vue'
    )
  },
  SENDORDERSEND: { // 全渠道发货单-发货
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/pages/orderCenter/omniChannel/dialog/dialogChargeOff.vue'
    )
  },
  NOTIFYSHIPMENTRE: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/pages/orderCenter/tbOrderManager/NOTIFYSHIPMENTRE.vue'
    ),
  },
  NOTIFYPURCHASE: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/NOTIFYPURCHASE.vue'
    ),
  },
  SG_B_STO_PURCHASE_PLAN_TRANSFER: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/planTransfer.vue'
    ),
  },
  REPLACEABNORMALGOODS: { // 唯品会退货单- 替换异常商品
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/replaceGoodsDetail.vue'
    ),
  },
  PAYDETAIL: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      'allpages/orderCenter/pay/payDetail.vue'
    ),
  },
  ORDERRETURN: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      'allpages/orderCenter/returnOrder/orderReturnchange.vue'
    ),
    labelName: $it('btn.back')
  },
  SAVE: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      'allpages/orderCenter/returnOrder/save.vue'
    ),
    labelName: $it('btn.save'), // 保存
  },
  // JIT配货单修改仓库测试弹框
  MODIFYWAREHOUSE: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/modifyWarehouse.vue'
    ),
  },
  // JIT拣货单 (创建拣货单)
  VIPCREATEPICKORDER: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/vipCreatePickorder.vue'
    )
  },
  // JIT配货单(手工占单)
  VIPDISTRIBUTIONOCCUS: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/vipDistributionOccus.vue'
    )
  },
  // JIT配货单(匹配出仓单)->改名为(匹配唯品会入库单)
  DELIVERYORDER: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/deliveryOrder.vue'
    )
  },
  // JIT PO单(下载PO单)
  VIPDOWNLOADPO: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/vipDownloadPo.vue'
    )
  },
  // JIT仓库管理(生成出仓单)
  JTWAREHOUSE: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/jtWarehouse.vue'
    )
  },
  MODIFYLOGISTICSNUMBER: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/modifyLogisticsNumber.vue'
    )
  },
  MODIFYWMS: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/modifyWms.vue'
    )
  },

  CREATEGRN: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/createGrn.vue'
    )
  },
  REFUSETOPAYOCBRETURNAFSEND: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/returngood/refuseToPayOcBReturnAfSend.vue'
    )
  },
  PICKORDEREXPORT: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/returngood/pickorderExport.vue'
    )
  },
  // JIT配货单-换吊牌
  EXCHANGETAG: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/exchangeTag.vue'
    )
  },
  CHANGETAG: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/changeTag.vue'
    ),
    labelName: '换吊牌',
    isList: false
  },
  MANUAL: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/manual.vue'
    )
  },
  FOURCE: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/force.vue'
    )
  },

  REMITFAIL:{
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/remitFail.vue'
    ) //
  },
  // 唯品会入库单-列表详情-修改发货时间button
  EDITCONSIGNMENTTIME: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/editConsignmentTime.vue')
  },
  // 零售发货单预导入 - 修改店铺
  PREORDERUPDATESHOP: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/preOrderUpdateShop.vue'
      )
  },
  // 零售发货单预导入 - 按流水转入
  TRANSFERREDBYFLOW: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/transferredByFlow.vue'
      )
  },
  // 零售发货单预导入 - 按流水转入
  preOrderImport: {
    component: () => import(
      /* webpackChunkName: 'OrderCenterModal' */
      '@/views/modal/orderCenter/preOrderImport.vue'
      )
  },
};
